import type { OpenDatesPayload } from '../api'

const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function fmtDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number)
  const dt = new Date(y, m - 1, d)
  return `${DOW[dt.getDay()]} ${MON[m - 1]} ${d}`
}

interface Props {
  data: OpenDatesPayload
}

export default function OpenDatesCard({ data }: Props) {
  const { venues, days_searched } = data

  return (
    <div
      style={{
        border: '1px solid var(--border)',
        borderRadius: '10px',
        overflow: 'hidden',
        fontSize: '13px',
        width: '100%',
        maxWidth: '520px',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '10px 14px',
          background: 'var(--card-bg, rgba(255,255,255,0.04))',
          borderBottom: '1px solid var(--border)',
          display: 'flex',
          alignItems: 'baseline',
          gap: '8px',
        }}
      >
        <span style={{ fontWeight: 600, color: 'var(--text)' }}>Open dates</span>
        <span style={{ color: 'var(--text-muted)', fontSize: '12px' }}>
          {venues.length} venue{venues.length !== 1 ? 's' : ''} · {days_searched}d window
        </span>
      </div>

      {venues.length === 0 ? (
        <div style={{ padding: '12px 14px', color: 'var(--text-muted)' }}>
          No scene venues with upcoming show data found.
        </div>
      ) : (
        venues.map((v, vi) => (
          <div
            key={v.venue}
            style={{
              padding: '10px 14px',
              borderBottom: vi < venues.length - 1 ? '1px solid var(--border)' : undefined,
            }}
          >
            {/* Venue name + stats */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '8px' }}>
              <span style={{ fontWeight: 600, color: 'var(--text)' }}>{v.venue}</span>
              <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                {v.open_dates.length} open · last show {v.last_show_date}
              </span>
            </div>

            {v.open_dates.length === 0 ? (
              <div style={{ color: 'var(--text-muted)', fontSize: '12px' }}>No open dates in range</div>
            ) : (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                {v.open_dates.map((d) => (
                  <span
                    key={d}
                    style={{
                      fontSize: '12px',
                      padding: '2px 8px',
                      borderRadius: '5px',
                      background: 'rgba(34,197,94,0.08)',
                      border: '1px solid rgba(34,197,94,0.2)',
                      color: 'var(--success, #22c55e)',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {fmtDate(d)}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  )
}
